<template>
    <modal v-model="showModal" @hidden="onHide" size="regular" ref="modal" data-backdrop="static" data-keyboard="false">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0" v-text="shopService.name"></h2>
                <div class="mt--2 heading-small" v-text="subtitle"></div>
            </div>
        </template>
        <div class="row">
            <div class="col-lg-12 mb-4">
                <h3 class="text-default text-sm" v-text="shopService.description"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Duration</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="shopService.duration"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Price</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="shopService.price"></h3>
            </div>
            <div class="col-sm-10 mt-3">
                <form-input
                    type="integer"
                    placeholder="Quantity"
                    label="Quantity"
                    v-model="shopService.quantity"
                    ref="quantity"
                ></form-input>
            </div>
            <div class="col-sm-10">
                <modal-selector
                    title="Service voucher"
                    label="Service voucher"
                    placeholder="Service voucher"
                    :fetch-link="voucherFetchLink"
                    :params="voucherParams"
                    paginate-path="data.result.vouchers"
                    v-model="shopService.voucher_id"
                    display-key="displayed_title"
                    sub-name-key="name"
                    ref="voucher"
                    @change="voucher => updateVoucher(voucher)"
                >
                </modal-selector>
            </div>
            <div v-if="!isPackage" class="col-sm-10">
                <modal-selector multiple
                    :max="shopService.quantity"
                    title="Select expert(s)"
                    label="Experts"
                    placeholder="Experts"
                    sub-name="Expert"
                    :fetch-link="expertFetchLink"
                    :params="fetchExpertsParam(shopService)"
                    paginate-path="data.result.experts"
                    v-model="shopService.experts"
                    display-key="fullname"
                    sub-text-key="class"
                    @change="experts => updatedExperts(shopService, experts)"
                    ref="experts"
                >
                </modal-selector>
            </div>
            <div v-if="!isPackage" class="col-sm-10">
                <form-input
                    type="textarea"
                    placeholder="Note"
                    label="Note"
                    v-model="shopService.note"
                    :rows="3"
                    ref="note"
                ></form-input>
            </div>
            <template v-else>
                <div class="col-12">
                    <div class="text-xs">Pacakge Items</div>
                </div>
                <div  v-if="!isRequesting" class="col-sm-12 mt-4" style="max-height: 420px; overflow: auto;">
                    <div v-for="(packageItem, key) in packageItems" :key="key" class="package-item-wrapper row">
                        <div class="col-4">
                            <div class="text-xs" v-text="(packageItem.subcategory || {}).name"></div>
                            <h3 class="font-weight-700 text-default text-sm mb--1" v-text="getPackageItemDisplayName(packageItem)"></h3>
                        </div>
                        <div class="col-4">
                            <div class="text-xs">Duration</div>
                            <h3 class="font-weight-700 text-default text-sm mb--1" v-text="getDisplayedDuration(packageItem)"></h3>
                        </div>
                        <div class="col-4">
                            <div class="text-xs">Quantity</div>
                            <h3 class="font-weight-700 text-default text-sm mb--1" v-text="packageItem.quantity"></h3>
                        </div>
                        <div class="col-sm-10">
                            <modal-selector multiple
                                :max="packageItem.quantity * shopService.quantity"
                                title="Select expert(s)"
                                label="Experts"
                                placeholder="Experts"
                                sub-name="Expert"
                                :fetch-link="expertFetchLink"
                                :params="fetchExpertsParam(packageItem)"
                                paginate-path="data.result.experts"
                                v-model="packageItem.experts"
                                display-key="fullname"
                                sub-text-key="class"
                                @change="experts => updatedExperts(packageItem, experts)"
                                ref="packageItemExperts"
                            >
                            </modal-selector>
                        </div>
                        <div class="col-sm-10 mt-3">
                            <form-input
                                type="textarea"
                                placeholder="Note"
                                label="Note"
                                v-model="packageItem.note"
                                ref="note"
                                :rows="2"
                            ></form-input>
                        </div>
                    </div>
                </div>
                <div v-else class="col-sm-12 mt-4">
                    <div class="text-xs mb-2">Pacakge Items</div>
                    <div class="font-weight-500">
                        <i class="fa fa-spinner fa-spin mr-2"></i> Loading package items
                    </div>
                </div>
            </template>
            <div class="col-sm-12 text-right mt-4">
                <button class="btn btn-warning" @click="update">
                    <i class="fa fa-save mr-2"></i> Save
                </button>
            </div>
        </div>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import { get, route } from '@utils/network';
import { getDisplayedDuration } from "@utils/helpers";
import ModalSelector from "@components/forms/selects/modal-selector/ModalSelector";

export default {
    name: 'ServiceModal',

    components: { ModalSelector },

    computed: {
        subcategory() {
            return this.shopService.subcategory || {};
        },
        isPackage() {
            return this.shopService.type === "package";
        },
        subtitle() {
            return !this.isPackage
                ? `${ this.shopService.type } - ${ this.subcategory.name }`
                : `${ this.shopService.type }`;
        },
        packageItems() {
            return this.shopService.packageItems || [];
        },
        voucherParams() {
            return {
                shop_id: this.$store.getters.shop.id,
                type: this.shopService.type,
                type_id: this.shopService.id
            };
        }
    },

    data: () => ({
        showModal: false,
        clearModal: true,
        isRequesting: false,
        shopService: {},
        expertFetchLink: route("shops/experts"),
        voucherFetchLink: route("vouchers"),
    }),

    methods: {
        getPackageItemDisplayName(packageItem) {
            return `${ packageItem.quantity || 1 }x ${ packageItem.name }`
        },
        getDisplayedDuration(service) {
            return getDisplayedDuration(service.duration || 0);
        },
        clearFields() {
            this.shopService = {};
        },

        show(shopService) {
            this.showModal = true;
            this.shopService = {...shopService};
            if (shopService.type === "package" && !this.shopService.packageItems) {
                this.fetchPackageItems();
            } else {
                this.$nextTick(() => this.initializeExperts(), 500);
            }
            this.$nextTick(() => this.initializeVoucher(), 500);
        },

        onHide(event) {
            if (event && event.target.id != this.$refs.modal.id) {
                return;
            }
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },


        fetchPackageItems() {
            this.isRequesting = true;
            get(route("shops/package-items"), { params: { package_id: this.shopService.id } })
                .then(response => this.shopService.packageItems = response.data.result.packageItems)
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                })
                .finally(() => this.isRequesting = false);
        },

        async update() {
            if (this.shopService.voucher && this.$parent.hasServiceVoucher()) {
                if (!(await this.confirm("Are you sure you want to apply this voucher?", "Please note that other vouchers used will be cleared.")).value) {
                    return;
                }
            }
            this.$emit("update", this.shopService)
            this.onHide();
        },
        fetchExpertsParam(service) {
            return {
                shop_id: service.shop_id || 0,
                subcategory_id: service.subcategory_id || 0,
                datetime: this.$parent.shopParams.datetime
            };
        },
        updatedExperts(service, experts) {
            service.selectedExperts = [...experts];
        },
        updateVoucher(voucher) {
            this.shopService.voucher = voucher;
        },
        updatedExperts(service, experts) {
            service.selectedExperts = [...experts];
        },
        initializeExperts() {
            if (this.shopService.type == "service") {
                return this.$nextTick(() => {
                    this.$refs.experts.clear();
                    this.$refs.experts.search(this.shopService.experts || [])
                });
            }
            this.$nextTick(() => {
                this.shopService.packageItems.forEach((packageItem, index) => {
                    this.$refs.packageItemExperts[index].clear();
                    this.$refs.packageItemExperts[index].search(packageItem.experts || []);
                });
            });
        },
        initializeVoucher() {
            return this.$nextTick(() => {
                this.$refs.voucher.clear();
                if (this.shopService.voucher_id) {
                    this.$refs.voucher.search([this.shopService.voucher_id])
                }
            });
        },
    },

    mixins: [ mixins ],
}
</script>
<style lang="css" scoped>
    .package-item-wrapper {
        padding: 1rem 0 0!important;
    }
    .package-item-wrapper::after {
        content: " ";
        width: 100%;
        padding-top: 1rem;
        display: block;
        margin: 0px 15px;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
</style>